import React, { memo, useEffect, useState, useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import fly from '../../static/pcStore.png';
import check_success from '../../static/check_success.svg';
import check_error from '../../static/check_error.svg';
import styles from './CheckUpdate.module.less';
import { setCheckUpdateVisible, setNewVersionInfo } from '../../actions/layout';
import { PCStoreJsBridge } from '../../nativeapi/index';
import { logging } from '../../actions/log';
import { logNative } from '../../utils/utils';
import { APP_VERSION, APP_VERSION_D } from '../../config';
import { cacheKeys } from '../../constants/storageKeys';
import Toast from '../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const [init, setInit] = useState(true);
  const [errors, setErrors] = useState(false);
  const [lastVersion, setLastVersion] = useState(null);
  const [version, setVersion] = useState(APP_VERSION);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    PCStoreJsBridge.isNeedUpdatePCStore().then(
      res => {
        setInit(false);
        if (res && res.versionName) {
          setLastVersion(res);
        } else {
          setNewVersionInfo(res || {});
        }
      },
      error => {
        setInit(false);
        setErrors(true);
        logNative('检测版本更新失败', error);
      },
    );
    const startInfoStr = localStorage.getItem(cacheKeys.START_INFO) || '{}';
    try {
      const startInfo = JSON.parse(startInfoStr);
      setVersion(startInfo.isDStore ? APP_VERSION_D : APP_VERSION);
    } catch (error) {}
  }, []);

  const handleBeginUpdate = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Update_Begin',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    Toast.error({
      content: '稍后,我们将关闭商店为您进行新版本安装',
    });
    PCStoreJsBridge.updatePCStore(lastVersion);
    dispatch(setCheckUpdateVisible(false));
  }, [lastVersion]);

  const handleUpdateIsNew = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Update_Is_New',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(setCheckUpdateVisible(false));
  });

  const handleCheckAgain = useCallback(() => {
    PCStoreJsBridge.isNeedUpdatePCStore().then(
      res => {
        setInit(false);
        if (res && res.versionName) {
          setLastVersion(res);
        } else {
          setNewVersionInfo(res || {});
        }
      },
      error => {
        setInit(false);
        setErrors(true);
        logNative('检测版本更新失败', error);
      },
    );
    dispatch(
      logging({
        category: 'C',
        action: 'Update_Check_again',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  const handleCheckAgainCancel = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Update_Check_Cancel',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(setCheckUpdateVisible(false));
  });

  const handleClose = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Update_Check_Close',
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(setCheckUpdateVisible(false));
  });

  const CloseNode = ({ hasBg }) => {
    return (
      <a
        className={classNames(styles.QRcode_close, { [styles.bg_close]: hasBg })}
        onClick={handleClose}
      >
        <i className="iconfont icon-close" />
      </a>
    );
  };
  if (init) {
    return null;
  }
  if (lastVersion) {
    return (
      <div className={styles.QRcode_bg}>
        <div className={classNames(styles.QRcode, styles.version_modal)}>
          <div className={styles.QRcode_title}>
            <div>
              <img src={fly} alt="" width="18px" />
              <span className={styles.text}>联想应用商店</span>
            </div>
            <div className={styles.content}>
              检测到新版本 {lastVersion && lastVersion.storeVersion}
            </div>
            <CloseNode />
          </div>

          <div className={styles.version_desc}>
            <div className={styles.version}>
              {lastVersion &&
                lastVersion.note &&
                lastVersion.note
                  .toString()
                  .split('\n')
                  // eslint-disable-next-line react/no-array-index-key
                  .map((item, index) => <div key={index}>{item}</div>)}
            </div>
          </div>
          <div className={styles.version_btn} onClick={handleBeginUpdate}>
            立即更新
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.QRcode_bg}>
      <div className={styles.check_complete}>
        <div className={styles.check_title}>
          <div className={styles.check_title_header}>
            <img src={fly} alt="" width="18px" />
            <span className={styles.text}>联想应用商店</span>
          </div>
          <CloseNode hasBg />
        </div>

        <div className={styles.check_content}>
          {!errors && (
            <>
              <img src={check_success} alt="" width="70px" />
              <div className={styles.check_desc}>当前已是最新版本：{version}</div>
              <div className={styles.check_btn} onClick={handleUpdateIsNew}>
                完成
              </div>
            </>
          )}
          {errors && (
            <>
              <img src={check_error} alt="" width="50px" />
              <div className={styles.check_desc}>版本更新失败，请重新更新</div>
              <div>
                <div
                  className={classNames(styles.check_btn_error, styles.check_btn)}
                  onClick={handleCheckAgain}
                >
                  确定
                </div>
                <div
                  className={classNames(styles.check_btn_error, styles.check_btn_cancel)}
                  onClick={handleCheckAgainCancel}
                >
                  取消
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
});
